import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { UserAccessLimits } from './accessLimitService'

interface AccessLimitsResponse {
    success: boolean
    message: string
    data: UserAccessLimits
}

export const accessLimitsRtkApi = createApi({
    reducerPath: 'accessLimitsRtkApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${(import.meta.env.VITE_API_URL || 'http://localhost:5000').replace(/\/api$/, '')}/api/v1`,
        credentials: 'include',
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('token')
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['AccessLimits'],
    endpoints: (builder) => ({
        getUserAccessLimits: builder.query<UserAccessLimits, void>({
            query: () => '/access-limits/user',
            transformResponse: (response: AccessLimitsResponse) => response.data,
            providesTags: ['AccessLimits'],
            keepUnusedDataFor: 30,
        }),

        canCreateGig: builder.query<
            {
                canCreate: boolean
                remaining: number
                limit: number
                isUnlimited: boolean
                requiresUpgrade: boolean
                subscriptionTier: string
                resetAt?: string
                current: number
                overrideActive: boolean
                upgradePrompt?: string
            },
            void
        >({
            query: () => '/access-limits/check/gig',
            transformResponse: (response: any) => response.data,
            providesTags: ['AccessLimits'],
            keepUnusedDataFor: 30,
        }),

        canApplyToGig: builder.query<
            {
                canApply: boolean
                remaining: number
                limit: number
                isUnlimited: boolean
                requiresUpgrade: boolean
                subscriptionTier: string
                resetAt?: string
                current: number
                overrideActive: boolean
                upgradePrompt?: string
            },
            void
        >({
            query: () => '/access-limits/check/application',
            transformResponse: (response: any) => response.data,
            providesTags: ['AccessLimits'],
            keepUnusedDataFor: 30,
        }),
    }),
})

export const {
    useGetUserAccessLimitsQuery,
    useCanCreateGigQuery,
    useCanApplyToGigQuery,
} = accessLimitsRtkApi
